import axios from 'axios'

export const baseURL = '/api/'

const armAxios = axios.create({
  baseURL
})

export default armAxios
